import { EntityTemplateVariables, TemplateVariable } from '@tools/interfaces/template';

export const getAccountingJournalFieldsForEntity = (entity: string): TemplateVariable[] => {
  return [
    {
      label: 'templates.accounting_journals.code.label',
      contentValue: `{{ ${entity}accountingJournal.code }}`,
      description: 'templates.accounting_journals.code.description',
    },
    {
      label: 'templates.accounting_journals.name.label',
      contentValue: `{{ ${entity}accountingJournal.name }}`,
      description: 'templates.accounting_journals.name.description',
    },
    {
      label: 'templates.accounting_journals.type.label',
      contentValue: `{{ ${entity}accountingJournal.type }}`,
      description: 'templates.accounting_journals.type.description',
    },
    {
      label: 'templates.accounting_journals.header_text.label',
      contentValue: `{{ ${entity}accountingJournal.header_text }}`,
      description: 'templates.accounting_journals.header_text.description',
    },
    {
      label: 'templates.accounting_journals.footer_text.label',
      contentValue: `{{ ${entity}accountingJournal.footer_text }}`,
      description: 'templates.accounting_journals.footer_text.description',
    },
    {
      label: 'templates.accounting_journals.external_id.label',
      contentValue: `{{ ${entity}accountingJournal.external_id }}`,
      description: 'templates.accounting_journals.external_id.description',
    },
    {
      label: 'templates.accounting_journals.status.label',
      contentValue: `{{ ${entity}accountingJournal.status }}`,
      description: 'templates.accounting_journals.status.description',
    },
  ];
};

export const templateAccountingJournal: EntityTemplateVariables = {
  fields: getAccountingJournalFieldsForEntity(''),
  related: [],
  relatedInLoop: [],
};
